<template>
	<div v-editable="blok" class="flex gap-1 text-sm items-center uppercase">
		<nuxt-link
			:to="link"
			class="nav-link text-xs nav-link-cms lg:border-b-[0.5px] lg:border-b-transparent lg:hover:border-primary tracking-[0.9px]"
			@click="closeMobileMenu"
		>
			{{ blok.name }}
		</nuxt-link>
	</div>
</template>

<script setup lang="ts">
import type { BlokMenuLink } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokMenuLink;
}
const { blok } = defineProps<Props>();

const localePath = useLocalePath();
const { resolveLink } = useStoryblokLink();
const link = computed(() => resolveLink(blok?.link) || localePath("/"));

const emit = defineEmits(["closeMobileMenu"]);
const closeMobileMenu = () => {
	emit("closeMobileMenu");
};
</script>
